import { sel, selAll } from '../utils'
import gsap from 'gsap'
// import { ScrollTrigger } from 'gsap/ScrollTrigger'
// gsap.registerPlugin(ScrollTrigger)

export default function TimedMod() {
  const modal$ = sel('.timed-mod')
  if (!modal$) return

  setTimeout(() => {
    const modalLastClosed = localStorage.getItem('timedModalLastClosed')
    const now = Date.now()
    const modalTimer = 2 * 60 * 60 * 1000 // 2 hours in milliseconds

    // If modal was closed less than * hours ago, don't show it
    if (modalLastClosed && now - parseInt(modalLastClosed) < modalTimer) {
      return
    }

    const modalMod$ = modal$.querySelector('.mod')
    const modalX$ = sel('.mod__x-w')
    const modalBg$ = sel('.mod-bg')

    gsap.set(modal$, { display: 'flex', opacity: 0 })
    const modTl = gsap
      .timeline()
      //
      .to(modal$, { opacity: 1, duration: 1, ease: 'power4.inOut' })
      .from(modalMod$, { y: 50, duration: 1, ease: 'power4.inOut' }, 0)

    ;[modalX$, modalBg$].forEach((el) => {
      el.addEventListener('click', () => {
        // Store the timestamp when user closes the modal
        localStorage.setItem('timedModalLastClosed', now.toString())

        modTl.reverse().then(() => {
          modal$.style.display = 'none'
        })
      })
    })
  }, 3000)
}
